import * as React from 'react';

import Icon from 'ha/ui/Icon';
import Link from 'ha/ui/Link';
import { Question as Props } from '../types';

interface State {
  hovered: boolean;
}

class Question extends React.Component<Props, State> {
  state: State = {
    hovered: false,
  };

  handleMouseEnter = () => {
    this.setState(() => ({ hovered: true }));
  };
  handleMouseLeave = () => {
    this.setState(() => ({ hovered: false }));
  };

  render() {
    return (
      <Link
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
        className="color-white flexbox flex-align-center"
        to={this.props.url}
        skipLangFormat
      >
        <Icon
          name={this.state.hovered ? 'circle' : 'circle-o'}
          className="m-r-1"
        />
        <span className="underline">{this.props.text}</span>
      </Link>
    );
  }
}

export default Question;
